var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.retryFailedShow,
          expression: "retryFailedShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "retryFailed" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\r\n            " +
              _vm._s(_vm.$t("language.common.failedFiles")) +
              "\r\n            "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "retry-body" }, [
          _vm.transferType == 1
            ? _c("div", { staticClass: "retry-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "retry-button",
                    on: {
                      click: function($event) {
                        return _vm.retry()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-util retry retry-button-position"
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("language.common.retry")) +
                        "\r\n                "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "failed-files-contens" }, [
            _vm.unfinishData.length < 1
              ? _c("div", {
                  staticClass: "failed_empty_tip",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("language.common.failedEmptyTip"))
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "all-failed-box" }, [
              _c(
                "table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
                },
                [
                  _c("thead", [
                    _c("tr", { staticClass: "retry-th" }, [
                      _c("th", { attrs: { width: "21.5%", fixed: "true" } }, [
                        _vm.transferType == 1
                          ? _c("div", {
                              staticClass: "icon-util failed-retry-position",
                              class:
                                _vm.selectedArr.length != 0 &&
                                _vm.selectedArr.length ==
                                  _vm.unfinishData.length -
                                    _vm.retryedArr.length
                                  ? "check-small"
                                  : "nocheck-small-blue",
                              staticStyle: { float: "left", top: "10Px" },
                              on: {
                                click: function($event) {
                                  return _vm.checkedAll()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.transferType == 2
                          ? _c("div", {
                              staticStyle: {
                                width: "10Px",
                                height: "10Px",
                                float: "left"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.selectedArr.length
                          ? _c("div", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(_vm.$t("language.common.name")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedArr.length
                          ? _c(
                              "div",
                              {
                                staticClass: "selected-style",
                                attrs: {
                                  title:
                                    _vm.selectedArr.length +
                                    _vm.$t("language.common.itemsSelected")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.selectedArr.length) +
                                    " " +
                                    _vm._s(
                                      _vm.$t("language.common.itemsSelected")
                                    )
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "13%", fixed: "true" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.size")))
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "26.5%", fixed: "true" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.sourceDir")))
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "27%", fixed: "true" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.cause")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.unfinishData, function(item, index) {
                      return _c(
                        "tr",
                        { key: index, staticClass: "failed-retry-tr" },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: { float: "left" },
                              attrs: { width: "21.5%" }
                            },
                            [
                              !item.retryed
                                ? _c("div", [
                                    _vm.transferType == 1
                                      ? _c("div", {
                                          staticClass:
                                            "icon-util failed-retry-position",
                                          class: _vm.selectedArr.includes(item)
                                            ? "check-small"
                                            : "nocheck-small-blue",
                                          staticStyle: {
                                            float: "left",
                                            "margin-right": "17px"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectItem(item)
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.transferType == 2
                                      ? _c("div", {
                                          staticStyle: {
                                            width: "10Px",
                                            height: "10Px",
                                            float: "left"
                                          }
                                        })
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.retryed
                                ? _c("div", [
                                    _c("div", {
                                      staticClass:
                                        "icon-util eye view-logs-eye failed-retry-position",
                                      attrs: { title: "View" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toAimRootCatalog()
                                        }
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.filename
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "failed-files-one",
                                      attrs: {
                                        title:
                                          item.fileid === "root0" ||
                                          item.fileid === "0"
                                            ? item.fromItem.name
                                            : item.filename
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.fileid === "root0" ||
                                            item.fileid === "0"
                                            ? item.fromItem.name
                                            : item.filename
                                        )
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "failed-files-one",
                                      attrs: { title: item.name }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          item.filesize || item.filesize == 0
                            ? _c(
                                "td",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { width: "15%" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatLogByte")(item.filesize)
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "td",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { width: "15%" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("formatLogByte")(item.size))
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          item.fromItem.driveType !== "Shares"
                            ? _c(
                                "td",
                                {
                                  staticClass: "item-dire",
                                  attrs: {
                                    width: "30%",
                                    title: _vm._f("getCatalogTitle")(
                                      _vm._f("getCatalog")(item.fromItem.nodes)
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.tofailedCategroy(item.fromItem)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCatalog")(item.fromItem.nodes)
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "td",
                                {
                                  staticClass: "item-dire",
                                  attrs: {
                                    width: "30%",
                                    title: _vm._f("getCatalogTitle")(
                                      _vm._f("getCatalogShare")(
                                        item.fromItem.nodes
                                      )
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toSharelicLink(item.fromItem)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getCatalogShare")(
                                        item.fromItem.nodes
                                      )
                                    )
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { float: "left" },
                              attrs: { width: "30%" }
                            },
                            [
                              (item.fromItem.driveType ===
                                "oneDrive4Business" ||
                                item.toItem.driveType ===
                                  "oneDrive4Business") &&
                              item.exception.includes("User's mysite not found")
                                ? _c("div", [
                                    item.cause
                                      ? _c(
                                          "div",
                                          { staticClass: "failed-files-two2" },
                                          [_vm._m(0, true)]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "failed-files-two2" },
                                          [_vm._m(1, true)]
                                        )
                                  ])
                                : _c("div", [
                                    item.cause
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "failed-files-two",
                                            attrs: {
                                              title: _vm._f("getCauseReason")(
                                                item.cause
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("getCauseReason")(
                                                  item.cause
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "failed-files-two",
                                            attrs: {
                                              title: _vm._f("getCauseReason")(
                                                item.exception
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("getCauseReason")(
                                                  item.exception
                                                )
                                              )
                                            )
                                          ]
                                        )
                                  ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.unfinishData.length >= 1000
            ? _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    top: "20px",
                    fontSize: "14px"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.cloudBackup.maxLogs")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "retry-footer" }, [
            _c(
              "a",
              {
                staticClass: "retry-limits",
                attrs: {
                  href: "https://www.multcloud.com/help/limitations.html",
                  target: "_blank"
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.popup.limits")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { title: "Access denied. Check for solutions" } },
      [
        _vm._v("Access denied."),
        _c(
          "a",
          {
            staticClass: "add-onedrivebuiness-link",
            attrs: {
              href:
                "https://www.multcloud.com/help/onedrive-business-access-denied-error.html",
              target: "_blank"
            }
          },
          [_vm._v(" Check for solutions")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { attrs: { title: "Access denied. Check for solutions" } },
      [
        _vm._v("Access denied."),
        _c(
          "a",
          {
            staticClass: "add-onedrivebuiness-link",
            attrs: {
              href:
                "https://www.multcloud.com/help/onedrive-business-access-denied-error.html",
              target: "_blank"
            }
          },
          [_vm._v(" Check for solutions")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ed6a0d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed6a0d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/view_failed_files_popups.vue
// module id = null
// module chunks = 